import { WordArray } from './core.js';
/**
 * ISO 10126 padding strategy.
 */

export var Iso10126 = {
  pad: function pad(data, blockSize) {
    // Shortcut
    var blockSizeBytes = blockSize * 4; // Count padding bytes

    var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes; // Pad

    data.concat(WordArray.random(nPaddingBytes - 1)).concat(WordArray.create([nPaddingBytes << 24], 1));
  },
  unpad: function unpad(data) {
    var _data = data; // Get number of padding bytes from last byte

    var nPaddingBytes = _data.words[_data.sigBytes - 1 >>> 2] & 0xff; // Remove padding

    _data.sigBytes -= nPaddingBytes;
  }
};